import script from "./CancellationReasonsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CancellationReasonsWidget.vue?vue&type=script&setup=true&lang=js"

import "./CancellationReasonsWidget.vue?vue&type=style&index=0&id=088c62bc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088c62bc"]])

export default __exports__